import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'partners-bar-chart',
})

export default class PartnersBarChart extends Vue {


    // ------------------------------------------------------------
    // Properties

    private margin = {top: 30, right: 15, bottom: 80, left: 30};

    @Prop({default: 900})
    private width!: number;

    @Prop({default: 400})
    private height!: number;

    @Prop({default: []})
    private chartData!: Array<{name: string, count: number, type: string}>;

    @Prop({default: null})
    private activeType!: any;

    @Watch('chartData', {deep: true})
    private onChangeChartData(value: any) {
        this.drawBarChart();
    }

    // ------------------------------------------------------------
    // Hooks

    private mounted() {
        this.drawBarChart();
    }


    // ------------------------------------------------------------
    // Methods

    private drawBarChart() {
        d3.select(this.$el).select('svg').remove();
        const margin = this.margin;
        let width = this.width;
        let height = this.height;
        width = width - margin.left - margin.right;
        height = height - margin.top - margin.bottom;
        const data = this.chartData;
        const svg: any = d3.select(this.$el).append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);
        const xAxis = d3.scaleBand()
            .range([0, width])
            .domain(data.map((item) => item.name))
            .padding(0.2);

        const yAxis: any = d3.scaleLinear()
            .domain([0, d3.max(data, (d) => d.count) as number])
            .range([height, 0]);

        svg.append('g')
           .attr('class', 'x-axis')
           .attr('transform',  `translate(${0}, ${height})`)
           .call(d3.axisBottom(xAxis));

        svg.append('g')
            .call(d3.axisLeft(yAxis).ticks(data.length));

        svg.selectAll('.mybar')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', (d: any) => `mybar ${this.activeType && d.type === this.activeType.type && 'activebar'}`)
            .attr('x', (d: any) => xAxis(d.name) as any)
            .attr('y', (d: any) => yAxis(d.count))
            .attr('width', xAxis.bandwidth())
            .attr('height', (d: any) => height - yAxis(d.count))
            .attr('tabindex', 0)
            .attr('role', 'link')
            .attr('aria-label', (d: any) => d.name as any)
            .on('click', (d: any, i: any, node: any) => {
                d3.selectAll('.activebar').classed('activebar', false);
                d3.select(node[i]).classed('activebar', true);
                this.$emit('onSelectType', d);
            })
            .on('keypress', (d: any, i: any, node: any) => {
                d3.selectAll('.activebar').classed('activebar', false);
                d3.select(node[i]).classed('activebar', true);
                this.$emit('onSelectType', d);
            });

        d3.selectAll('.mybar')
            .each((d: any) => {
                svg.append('text')
                .attr('class', 'bar-text-item')
                .text(d.count)
                .attr('x', xAxis(d.name) as number + (xAxis.bandwidth() / 2))
                .attr('y', yAxis(d.count) - 5);
            });

    }


}
